export const parseApiError = (error: any): string => {
  // graphql-request throws ClientError with error.response.errors[]
  const gqlMessage = error?.response?.errors?.[0]?.message;
  if (gqlMessage) return gqlMessage;

  // Sometimes error.message is a stringified JSON blob
  if (typeof error?.message === 'string') {
    try {
      const parsed = JSON.parse(error.message);
      const nested = parsed?.response?.errors?.[0]?.message;
      if (nested) return nested;
    } catch {
      return error.message;
    }
  }

  return 'Something went wrong. Please try again.';
};
